import axios from "axios";
import { Base_URL } from "../url";

export const uploadBankStatements = async (formData, userId) => {
  try {
    const response = await axios.post(
      `${Base_URL}/BankStatementsData/UploadBankStatementCSV?UserName=${userId}`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.log("Error", error);
    throw error.response?.data;
  }
};

export const getBankNames = async (id) => {
  try {
    const response = await axios.get(
      `${Base_URL}/HouseBank/GetAllDistinctBanks/id?id=${id}`
    );
    return response.data.map((bank) => ({
      value: bank,
      label: bank,
    }));
  } catch (error) {
    throw error.response?.data || "Error fetching bank names!";
  }
};

export const getAccountNumbers = async (bankName, userId,id) => {
  try {
    const response = await axios.post(
      `${Base_URL}/HouseBank/GetHouseBanksByType/${id}?Type=${encodeURIComponent(
        bankName
      )}`
    );
    return response.data.map((account) => ({
      value: account.accountNumber,
      label: account.accountNumber,
    }));
  } catch (error) {
    throw error.response?.data || "Error fetching account numbers!";
  }
};

export const getAllBankStatements = async (id) => {
  try {
    const response = await axios.get(
      `${Base_URL}/BankStatementsData/GetAllBankStatements/id?id=${id}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching bank statements:", error);
    throw error.response?.data || "Error fetching bank statements!";
  }
};

export const getFileTypes = async () => {
  return [
    { value: "PDF", label: "PDF" },
    { value: "Excel", label: "Excel" },
    { value: "CSV", label: "CSV" },
  ];
};
